module.exports = __webpack_public_path__ + "img/wx-code.8fe8be88.jpg";